<template>
  <div class="left-content">
    <div class="container">
      <div class="imgWrap" v-for="(item,index) in imgData" :key="index">
        <img :src="item | imageUrl('',296,167)" alt @click="show(item)">
        <el-dialog :visible.sync="dialogVisible" width="14rem">
          <img class="diaimg" :src="imgUrl | imageUrl('')" alt>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import pages from "@/components/pages.vue";

export default {
  metaInfo () {
      return {
        title: this.$t('global.活动照片') + " | MANA"
      }
  },
  components: {
    pages
  },
  data() {
    return {
      imgData: [],
      dialogVisible: false,
      imgUrl: ""
    };
  },
  watch: {
    $route: function() {
      let currentID = this.$route.params.id;
      if (currentID == this.detailData.id) return;
      this.getData(this.$route.params.id);
    }
  },

  methods: {
    getData(activityId) {
      this.$http
        .get("/api/activity/detail", {
          params: {
            activityId: activityId
          }
        })
        .then(data => {
          let d = data.data;
          this.imgData = d.imageList;
        });
    },
    show(url) {
      this.dialogVisible = true;
      this.imgUrl = url;
    }
  },

  created() {
    this.getData(this.$route.params.id);
  }
};
</script>

<style lang="stylus" scoped>
.container:after {
  content: '';
  display: block;
  clear: both;
}

.imgWrap {
  width: 3.36rem;
  margin: 0.11rem 0.11rem;
  float: left;
  border-radius: 6px;
  -webkit-box-shadow: 2px 2px 2px #eaeaea;
  box-shadow: 2px 2px 2px #eaeaea;
  overflow: hidden;

  >img {
    width: 3.36rem;
    height: 2.02rem;
    display: block;
    cursor: pointer;

    &:hover {
      transform: scale(1.1);
      transition-duration: 0.5s;
    }
  }
}

.left-content {
  display: flex;
  /* justify-content space-between */
  flex-wrap: wrap;
  width: 720px;
  padding: 20px;
  background-color: #ffffff;

  .container {
    width: 100%;
  }
}

.diaimg {
  display: block;
  max-width: 13rem;
  height: 8rem;
}

.imgWrap >>> .el-dialog {
  height: 9rem;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.imgWrap >>> .el-dialog__body {
  max-height: 7.6rem;
  padding-bottom: 0.3rem;
  overflow: hidden;
}

.imgWrap >>> .el-dialog__header {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/match/Picture.vue